import React from 'react';

import {
    Grid,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Skeleton,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

const Placeholder = () => (
    <List>
        <ListItem alignItems="flex-start">
            <ListItemAvatar>
                <Skeleton variant="circular" width={40} height={40} />
            </ListItemAvatar>
            <ListItemText
                primary={
                    <React.Fragment>
                        <Skeleton></Skeleton>
                    </React.Fragment>
                }
                secondary={
                    <React.Fragment>
                        <Skeleton></Skeleton>
                    </React.Fragment>
                }
            />
        </ListItem>

        {[...Array(2)].map((_, index) => (
            <ListItem key={Math.random() + index} alignItems="flex-start">
                <ListItemText
                    primary={
                        <React.Fragment>
                            <Skeleton></Skeleton>
                        </React.Fragment>
                    }
                    secondary={
                        <React.Fragment>
                            <Skeleton></Skeleton>
                        </React.Fragment>
                    }
                />
            </ListItem>
        ))}

        <Grid container spacing={1} mt={1}>
            <Grid size={{ sm: 4, xs: 18 }}>
                <ListItem alignItems="flex-start">
                    <ListItemText
                        primary={
                            <React.Fragment>
                                <Skeleton></Skeleton>
                            </React.Fragment>
                        }
                        secondary={
                            <React.Fragment>
                                <Skeleton></Skeleton>
                            </React.Fragment>
                        }
                    />
                </ListItem>
            </Grid>

            <Grid size={{ sm: 4, xs: 18 }}>
                <ListItem alignItems="flex-start">
                    <ListItemText
                        primary={
                            <React.Fragment>
                                <Skeleton></Skeleton>
                            </React.Fragment>
                        }
                        secondary={
                            <React.Fragment>
                                <Skeleton></Skeleton>
                            </React.Fragment>
                        }
                    />
                </ListItem>
            </Grid>

            <Grid size={{ sm: 4, xs: 18 }}>
                <ListItem alignItems="flex-start">
                    <ListItemText
                        primary={
                            <React.Fragment>
                                <Skeleton></Skeleton>
                            </React.Fragment>
                        }
                        secondary={
                            <React.Fragment>
                                <Skeleton></Skeleton>
                            </React.Fragment>
                        }
                    />
                </ListItem>
            </Grid>
        </Grid>
    </List>
);

const PlaceholderGeneralInfoCard = ({ children, ready }) => {
    return <>{ready ? <Placeholder /> : children}</>;
};

PlaceholderGeneralInfoCard.propTypes = {
    children: PropTypes.node,
    ready: PropTypes.bool,
};

export default PlaceholderGeneralInfoCard;
